import { evaluateCondition } from '../evaluators/conditionEvaluator';
import type { Condition } from '../types/conditions';
import type { FormEachNode } from '../types/layout';

export function isDragReorderAvailable(node: FormEachNode): boolean {
  return node.sortable === true;
}

export function evaluateEachCondition(
  condition: Condition | Record<string, unknown> | undefined,
  values: Record<string, unknown>,
  meta: Record<string, unknown>,
): boolean {
  if (condition == null) return true;
  return evaluateCondition(condition as Condition, { values, meta });
}

export function canShowEachAddButton(
  node: FormEachNode,
  fieldCount: number,
  isReadOnly: boolean,
  values: Record<string, unknown>,
  meta: Record<string, unknown>,
): boolean {
  if (isReadOnly) return false;
  if (node.maxItems != null && fieldCount >= node.maxItems) return false;

  const visibleWhen = node.addButton?.visibleWhen ?? node.addVisibleWhen;
  if (visibleWhen != null && !evaluateEachCondition(visibleWhen, values, meta)) {
    return false;
  }

  return true;
}

export function canShowEachRemoveButton(
  node: FormEachNode,
  fieldCount: number,
  isReadOnly: boolean,
  values: Record<string, unknown>,
  meta: Record<string, unknown>,
): boolean {
  if (isReadOnly) return false;
  if (node.minItems != null && fieldCount <= node.minItems) return false;

  if (node.removeVisibleWhen != null && !evaluateEachCondition(node.removeVisibleWhen, values, meta)) {
    return false;
  }

  return true;
}

export function resolveRemovePresentation(node: FormEachNode): 'button' | 'inline-icon' | 'hidden' {
  if (
    node.removeButton?.position === 'inline' ||
    node.removeButton?.variant === 'inline-icon' ||
    node.removeStyle === 'inline-icon'
  ) {
    return 'inline-icon';
  }
  if (node.removeStyle === 'hidden') {
    return 'hidden';
  }
  return 'button';
}
